var React = require('react');

function DanceSteps (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.5,49.69l15.75-4S35.61,62.91,26,66.42,10.5,49.69,10.5,49.69Z","key":0}),React.createElement("path",{"d":"M8.51,42.17l15.7-3.3s7.11-18.46-5.86-32.65c0,0-9.27-10.79-14.9,2.13C3.45,8.35-2.1,21.71,8.51,42.17Z","key":1}),React.createElement("path",{"d":"M70.33,76.31l-14.14-8s-13.57,14.2-5.26,20.1S70.33,76.31,70.33,76.31Z","key":2}),React.createElement("path",{"d":"M74.22,69.58l-14.29-7.3s-2-19.68,14.21-30c0,0,11.78-8,13.82,6C88,38.27,89.81,52.62,74.22,69.58Z","key":3}),React.createElement("path",{"strokeDasharray":"2 6","d":"M33.75,24.16S58.08,39.67,49.36,67.74","key":4})]);
}

DanceSteps.defaultProps = {"className":"svg-dance-steps","viewBox":"0 0 90.03 91.57","stroke":"#000000","fill":"none"};

module.exports = DanceSteps;

DanceSteps.default = DanceSteps;
